import { lazy } from "react";
import { Activity } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const syncMonitorFeature: FeatureDescriptor = {
  id: "sync_monitor",
  flag: "sync_monitor",
  path: "/sync-monitor",
  group: "admin",
  navKey: "nav.syncMonitor",
  icon: Activity,
  roles: ["admin"],
  element: lazy(() => import("./SyncMonitorPage")),
};
